module.exports = __webpack_public_path__ + "img/icon-b-play-dark.f0e5c223.svg";